import React from 'react'
import Paginator from '@shared/Paginator/Paginator'
import * as S from './ui.styled'
import { useList, useStore } from 'effector-react'
import { $paginationGoods } from 'src/widgets/pagination-goods/model'
import CatalogGoodItem from '@components/CatalogGoodItem/CatalogGoodItem'
import { $shipment } from '@entities/shipment/model'
import { useGoodsFilteredIsEmpty } from 'src/features/filter-goods/model/goods-result'
import { GoodItemSkeletonDesktop } from 'src/widgets/good-element/ui/good-item-skeleton-desktop'
import { $isLoadingGoods } from 'src/widgets/good-element/model'

function SkeletonCatalog() {
    return (
        <React.Fragment>
            <GoodItemSkeletonDesktop />
            <GoodItemSkeletonDesktop />
            <GoodItemSkeletonDesktop />
            <GoodItemSkeletonDesktop />
            <GoodItemSkeletonDesktop />
        </React.Fragment>
    )
}

export const GoodsWithPagination = () => {
    const shipment = useStore($shipment)
    //const currentPath = useStore($currentPath)
    const goodsFilteredIsEmpty = useGoodsFilteredIsEmpty()
    const goods = useList($paginationGoods, {
        fn: (good) => <CatalogGoodItem shipment={shipment}>{good}</CatalogGoodItem>,
        getKey: (good) => good.webData.goodId
    })
    const isLoading = useStore($isLoadingGoods)
    if (isLoading)
        return (
            <S.GoodsContainer>
                <S.GoodListContainer>
                    <S.GoodList>
                        <SkeletonCatalog />
                    </S.GoodList>
                </S.GoodListContainer>
            </S.GoodsContainer>
        )
    return (
        <S.GoodsContainer>
            <Paginator />
            <S.GoodListContainer>
                <S.GoodList>
                    {goodsFilteredIsEmpty && <S.SearchTitle>Ничего не найдено</S.SearchTitle>}
                    {goods}
                </S.GoodList>
            </S.GoodListContainer>
            <Paginator />
        </S.GoodsContainer>
    )
}
